/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Button, Row, Col, DatePicker, Select, Table, Upload, message, Icon } from 'antd';
import moment from 'moment';
import { DmsTab, DisplayForm, TableView } from 'Components';
import { openNotice } from 'Utils';
import ProductModal from '../inventory/productModal';
import { getPaymentDetail, payListByriskId } from '../../service/financialMgm';
const FormItem = Form.Item;

class PaymentDetail extends React.Component {
  
  constructor (props) {
    super(props);
    this.state = {
      opts: ['应付详情'],
      btnLoad: false,
      detail: {
        productId: '',
        price: ''
      },
      endOpen: false, // 控制失效时间选择
      rows: [{
          key: '0',
          id: '1',
          status: '10010101',
          type: '2017-12-29',
          date: '100',
          customerName: '10',
          purchaseUnit: '300',
          amount: '个啊实打实大',
          cash: '100',
          date1: '已提交',
          customerName1: '2017-12-12',
          purchaseUnit1: '1111111'
        }, {
          key: '1',
          id: '2',
          status: '10010102',
          type: '2017-12-30',
          date: '200',
          customerName: '20',
          purchaseUnit: '222',
          amount: '件休闲鞋',
          cash: '200',
          date1: '已提交',
          customerName1: '2017-12-12',
          purchaseUnit1: '1111111'
        }],
      total: 1,
      searchObj: {
        id: '',
        s: 10,
        p: 1
      },
      payRows: [],  // 已付记录列表
      paySearchObj: { // 已付记录列表
        riskId: '',
        s: 10,
        p: 1
      },
      payTotal: 1,
      loading: true,
      payLoading: true
    }
  }

  goBack = () => {
    hashHistory.goBack();
  };

  disabledStartDate = (startValue) => {
  }
  disabledEndDate = (endValue) => {
  }
  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  }
  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  }

  /* 核销订单记录翻页 */
  pageChange (page, pageSize) {
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, () => {
      this.initData();
    });
  }

  /* 已付记录翻页 */
  payPageChange (page, pageSize) {
    this.setState({ paySearchObj: { ...this.state.paySearchObj, s: pageSize, p: page } }, () => {
      this.initData();
    });
  }

  /*获取详情数据*/
  initData () {
    // this.state.searchObj.id = this.state.paySearchObj.riskId = this.props.routeParams.id;
    var obj = this.state.searchObj;
    this.setState({
      loading: true,
      payLoading: true
    })
    getPaymentDetail(obj).then(result => {
      if (result.status) {
        let detail = JSON.parse(JSON.stringify(result.data));
        // console.log(detail);
        // delete detail.writenoffDetailVos;
        this.setState({
          rows: detail.tgTransWritenoffs || [],
          total: result.total,
          detail: detail,
          loading: false
        });
        let obj = this.state.paySearchObj;
        payListByriskId(obj).then(res => {
          this.setState({
            payRows: res.data || [],
            payTotal: res.total,
            payLoading: false
          });
        });
      } else {
        message.error(result.message);
      }
    })
  }

  componentDidMount () {
    // console.log(this);
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        id: this.props.routeParams.id
      },
      paySearchObj: {
        ...this.state.paySearchObj,
        riskId: this.props.routeParams.id
      }
    }, () => {
      this.initData();
    });
    
    //设置离开当前路由时的钩子函数
    // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  render () {
    const { opts, detail, btnLoad, endOpen, rows, total, searchObj, paySearchObj, payRows, payTotal, payLoading, loading } = this.state;
    const props = {
  	  name: 'file',
  	  action: '//jsonplaceholder.typicode.com/posts/',
  	  headers: {
  	    authorization: 'authorization-text',
  	  },
  	  onChange(info) {
  	    if (info.file.status !== 'uploading') {
  	      console.log(info.file, info.fileList);
  	    }
  	    if (info.file.status === 'done') {
  	      message.success(`${info.file.name} file uploaded successfully`);
  	    } else if (info.file.status === 'error') {
  	      message.error(`${info.file.name} file upload failed.`);
  	    }
  	  },
  	};
    let self = this;
    const tableViewProps = {
      loading: loading,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total: total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange.bind(this)
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          render: (text, record, index) => {
            let _index = (this.state.searchObj.p - 1) * this.state.searchObj.s + index + 1;
            return _index;
          }
        }, {
          title: '订单号',
          dataIndex: 'orderNum'
        },
        {
          title: '订单时间',
          dataIndex: 'orderDate'
        },
        {
          title: '订单金额',
          dataIndex: 'orderAmount',
            render: (text, record, index) => {
                return Number(record.orderAmount).toFixed(2);
                //console.log(record.orderAmount);
            }
        },
        {
          title: '已核销金额',
          dataIndex: 'writenoffCount',
            render: (text, record, index) => {
                return Number(record.writenoffCount).toFixed(2);
                //console.log(record.orderAmount);
            }
        },
        {
          title: '未核销金额',
          dataIndex: 'unWritenoffCount',
            render: (text, record, index) => {
                return Number(record.unWritenoffCount).toFixed(2);
                //console.log(record.orderAmount);
            }
        },
        {
          title: '本次核销金额',
          dataIndex: 'writenoffCountCur',
            render: (text, record, index) => {
                return Number(record.writenoffCountCur).toFixed(2);
                //console.log(record.orderAmount);
            }
        }
      ],
      rows
    };
    /* 已付记录 */
    const payViewProps = {
      loading: payLoading,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total: payTotal,
        current: paySearchObj.p,//当前页码
        pageSize: paySearchObj.s,//当前分页数
        onChange: this.payPageChange.bind(this)
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          render: (text, record, index) => {
            let _index = (this.state.paySearchObj.p - 1) * this.state.paySearchObj.s + index + 1;
            return _index;
          }
        },
        {
          title: '付款日期',
          dataIndex: 'riskDate'
        },
        {
          title: '付款金额',
          dataIndex: 'riskCount'
        }
      ],
      rows: payRows
    };
    
    const displayData = [
      {label: '编号', value: detail.riskCode},
      {label: '应付日期', value: new Date(detail.riskDate).format('yyyy-MM-dd')},
      {label: '费用类型', value: detail.riskType},
      {label: '客户名称', value: detail.cusName},
      {label: '应付金额', value: detail.riskCountShould || 0},
      {label: '已付金额', value: detail.riskCountReal},
      {label: '已核销订单金额', value: detail.writenoffCount},
      {label: '可核销金额', value: detail.writenoffCountAble},
      {label: '收款凭证', value: detail.attachmentDto, type: 'attachList', clickFn: function(item){
        console.log(item);
      }}
    ];

    return <div>
      <DmsTab options={opts} defaultKey={0}>
        <Button onClick={this.goBack}>返回</Button>
      </DmsTab>
      <div className="dms-table-box">
        <DisplayForm dataSource={displayData} perRow="2"/>
        <div>
          <DmsTab className="white-bg no-border" options={['核销订单记录']} defaultKey={0}/>
          <div className="dms-table-box">
            <TableView {...tableViewProps}/>
          </div>
        </div>
        <div>
         {/* <DmsTab className="white-bg no-border" options={['已付记录']} defaultKey={0}/>
          <div className="dms-table-box">
            <TableView {...payViewProps}/>
          </div>*/}
        </div>
      </div>
    </div>
  }
};
export default PaymentDetail;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/paymentDetail.js